import inView from "in-view";

export default function initCountUp() {
  const isPresent = document.querySelector(".countup");
  if (!isPresent) {
    return;
  }

  const animationDuration = 2000;
  const frameDuration = 1000 / 60;
  const totalFrames = Math.round(animationDuration / frameDuration);
  const easeOutQuad = (t) => t * (2 - t);

  const animateCountUp = (el) => {
    let frame = 0;
    const originalText = el.innerHTML;
    const countTo = parseFloat(originalText);
    const decimalPlaces =
      originalText.indexOf(".") !== -1 ? originalText.split(".")[1].length : 0;

    const counter = setInterval(() => {
      frame++;
      const progress = easeOutQuad(frame / totalFrames);
      const currentCount = countTo * progress;
      const currentCountFormatted = currentCount.toFixed(decimalPlaces);

      if (el.innerHTML !== currentCountFormatted) {
        el.innerHTML = currentCountFormatted;
      }

      if (frame === totalFrames) {
        el.innerHTML = originalText; // Ensure the final value is exact
        clearInterval(counter);
      }
    }, frameDuration);
  };

  const runAnimations = () => {
    const countupEls = document.querySelectorAll(".countup");
    countupEls.forEach(animateCountUp);
  };

  inView(".countup").once("enter", runAnimations);
}
